import React from 'react';

import { useDocumentRequestHooks } from './document-request-hooks';
import { DocumentRequestScene } from './document-request-scene';

export const DocumentRequest = () => {
  const {
    t,
    phase,
    documentRequestInfo,
    isRedeeming,
    showRedeemRetry,
    isSendButtonDisable,
    onConfirm,
    onCloseWindow,
    onAddFile,
    onRemoveFile,
    uploadIsLoading,
    onSendFiles
  } = useDocumentRequestHooks();

  return (
    <DocumentRequestScene
      t={t}
      phase={phase}
      documentRequestInfo={documentRequestInfo}
      isRedeeming={isRedeeming}
      showRedeemRetry={showRedeemRetry}
      isSendButtonDisable={isSendButtonDisable}
      onConfirm={onConfirm}
      closeWindow={onCloseWindow}
      onAddFile={onAddFile}
      onRemoveFile={onRemoveFile}
      uploadIsLoading={uploadIsLoading}
      onSendFiles={onSendFiles}
    />
  );
};
